module.exports = __webpack_public_path__ + "img/preview-5.f72fd81d.webp";